/* eslint-disable react/prop-types */
import { FC, forwardRef, MouseEvent, ReactNode } from 'react'
import { NavLink, NavLinkProps } from 'react-router-dom'
import ListItem from '@material-ui/core/ListItem'

interface AppMenuItemComponentProps {
    className?: string
    link?: string | null // because the InferProps props allows null value
    onClick?: (event: MouseEvent<HTMLElement>) => void
    children?: ReactNode
}

const AppMenuItemComponent: FC<AppMenuItemComponentProps> = (props: AppMenuItemComponentProps) => {
    const { className, onClick, link, children } = props

    if (!link || typeof link !== 'string') {
        return (
            <ListItem
                button
                className={className}
                onClick={onClick}
            >{children}
            </ListItem>
        )
    }

    return (
        <ListItem
            button
            className={className}
            component={forwardRef(function CustomNavLink(props: NavLinkProps, ref: any) { return <NavLink {...props} exact={props.to === '/'} innerRef={ref} /> })}
            to={link}
        >
            {children}
        </ListItem>
    )
}

export default AppMenuItemComponent
